// İSG uzmanı portalı — ortak araç çekmecelerinin (`VehicleFormSheet`, `PermitVehicleAddSheet`) bağı:
// taşeronun araç kaydı §23.1 (`vehiclesApi`), izne bağlama §23.3 (`permitsApi`).
// contractorUuid anahtarda → başka taşeronun araçları servis edilmez; boşken liste çekilmez.

import { type VehicleClient, permitsApi, vehiclesApi } from '@isgportal/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { contractorsKeys } from './contractorsKeys';
import { invalidateVehicleCaches } from './vehicleCache';

export function useVehicleClient(contractorUuid: string): VehicleClient {
  const queryClient = useQueryClient();
  return useMemo<VehicleClient>(
    () => ({
      registryKey: contractorsKeys.vehicles(contractorUuid),
      registryEnabled: contractorUuid.length > 0,
      listRegistry: () => vehiclesApi.listContractorVehicles(contractorUuid),
      saveVehicle: (uuid, body) =>
        uuid === null
          ? vehiclesApi.createContractorVehicle(contractorUuid, body)
          : vehiclesApi.updateContractorVehicle(contractorUuid, uuid, body),
      linkToPermit: (permitUuid, body) => permitsApi.addPermitVehicle(permitUuid, body),
      invalidate: () => invalidateVehicleCaches(queryClient, contractorUuid),
    }),
    [contractorUuid, queryClient],
  );
}
